import React from "react";
import {
  UpdateQuestionMutationVariables,
  useQuestionQuery,
  useUpdateQuestionMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateQuestion] = useUpdateQuestionMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useQuestionQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/page"} replace />;
  }

  const handleUpdateQuestion = async (data: UpdateQuestionMutationVariables) => {
    try {
      await updateQuestion({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "Question updated",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/question");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.question}
      id={id}
      handleUpdateQuestion={handleUpdateQuestion}
    />
  );
};

export default Update;
